import { render } from "./commTable.vue?vue&type=template&id=076bfe66&scoped=true"
import script from "./commTable.vue?vue&type=script&lang=js"
export * from "./commTable.vue?vue&type=script&lang=js"

import "./commTable.vue?vue&type=style&index=0&id=076bfe66&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076bfe66"]])

export default __exports__